import { Documents } from '../documents'

export const ClientDocuments = Documents
